import React, { useEffect, useState } from 'react';
import {
  Box, Table, Thead, Tbody, Tr, Th, Td, Text, HStack, Badge, Icon,
} from '@chakra-ui/react';
import { MdAccountBalance } from 'react-icons/md';
import { ImmOrden, ordenesDesdeJuzgado } from '../../../api/immApi';
import { fmt, IMM_COLOR, EstatusBadge } from '../_shared';

const VinculoBadges: React.FC<{ orden: ImmOrden }> = ({ orden }) => (
  <HStack spacing={1} flexWrap="wrap">
    {orden.causaId != null && <Badge colorScheme="purple" fontSize="0.65rem">Causa</Badge>}
    {orden.audienciaId != null && <Badge colorScheme="blue" fontSize="0.65rem">Audiencia</Badge>}
    {orden.detencionId != null && <Badge colorScheme="orange" fontSize="0.65rem">Detención</Badge>}
    {orden.causaId == null && orden.audienciaId == null && orden.detencionId == null && <Text fontSize="xs" color="gray.400">—</Text>}
  </HStack>
);

const OrdenesDesdeJuzgado: React.FC = () => {
  const [data, setData] = useState<ImmOrden[]>([]);
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    setCargando(true);
    ordenesDesdeJuzgado()
      .then(setData)
      .catch(() => setData([]))
      .finally(() => setCargando(false));
  }, []);

  return (
    <Box bg="white" borderRadius="md" boxShadow="sm" borderLeft={`4px solid ${IMM_COLOR}`} p={4}>
      <HStack spacing={2} mb={3}>
        <Icon as={MdAccountBalance} boxSize={5} color={IMM_COLOR} />
        <Box>
          <Text fontWeight="bold" color={IMM_COLOR}>Órdenes vinculadas desde el Juzgado / Seguridad</Text>
          <Text fontSize="xs" color="gray.500">Registros recibidos desde otras instancias. Solo lectura.</Text>
        </Box>
      </HStack>
      <Box overflowX="auto">
        <Table variant="simple" size="sm">
          <Thead bg={IMM_COLOR}>
            <Tr>
              <Th color="white" fontSize="xs">No. expediente</Th>
              <Th color="white" fontSize="xs">Autoridad</Th>
              <Th color="white" fontSize="xs">Emisión</Th>
              <Th color="white" fontSize="xs">Estatus</Th>
              <Th color="white" fontSize="xs">Vínculos</Th>
            </Tr>
          </Thead>
          <Tbody>
            {cargando ? (
              <Tr><Td colSpan={5} textAlign="center" py={6}><Text color="gray.500">Cargando...</Text></Td></Tr>
            ) : data.length === 0 ? (
              <Tr><Td colSpan={5} textAlign="center" py={6}><Text color="gray.400">Sin órdenes vinculadas desde el Juzgado / Seguridad</Text></Td></Tr>
            ) : (
              data.map((item, idx) => (
                <Tr key={item.id} bg={idx % 2 === 0 ? 'white' : 'gray.50'} _hover={{ bg: 'red.50' }}>
                  <Td>{item.numeroExpediente || '—'}</Td>
                  <Td>{item.autoridadEmisora || '—'}</Td>
                  <Td>{fmt(item.fechaEmision)}</Td>
                  <Td><EstatusBadge value={item.estatus} /></Td>
                  <Td><VinculoBadges orden={item} /></Td>
                </Tr>
              ))
            )}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};

export default OrdenesDesdeJuzgado;
